var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCrossDevice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cross_device_svg__clip0_175_1852)",
    fill: "#979797"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.207 11.96H1.122c-.297 0-.582-.12-.793-.334A1.15 1.15 0 010 10.821v-9.68C0 .837.119.547.33.334.54.12.824 0 1.121 0h14.299c.297 0 .582.12.792.335.21.213.33.503.33.805V6.79h-3.336v5.17zM1.262 10.68h10.685V6.626c0-.297.116-.582.323-.792.207-.21.487-.328.78-.328h2.233V1.28H1.262v9.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.457 15.002h-4.37V10.68h4.37v4.323zm-3.112-1.28h1.853V11.96H7.345v1.763z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.207 11.96H1.122c-.297 0-.582-.12-.793-.334A1.15 1.15 0 010 10.821V8.314h13.207v3.645zM1.262 10.68h10.685V9.586H1.262v1.092z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9 15.002h-3.85c-.293 0-.573-.119-.78-.329a1.132 1.132 0 01-.323-.791V6.627c0-.297.116-.582.323-.792.207-.21.487-.328.78-.328h3.85c.292 0 .572.118.779.328.207.21.323.495.323.792v7.252c0 .298-.117.583-.323.793-.207.21-.487.329-.78.33zm-3.694-1.28h3.532V6.79h-3.532v6.933zM11.637 13.72H4.903V15h6.734v-1.28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.595 11.813h-1.243v1.28h1.243v-1.28z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cross_device_svg__clip0_175_1852"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h18v15H0z"
  })))));
}
export default SvgCrossDevice;